<template>
  <div class="credit-info">
    <section class="main-section">
      <div class="column">
        <img class="logo" src="@/assets/landing-credit-info/logo-m.svg" alt="logo">

        <div class="title-wrapper">
          <h1 class="fn-title-1 main-title">
            Кредити на розвиток бізнесу
            <span class="subtitle">від Альянс Банк</span>
          </h1>

          <button class="large-btn main-btn second-color" v-scroll-to="'#credits'">Обрати кредит</button>
        </div>
      </div>
      <div class="column main-banner"></div>
    </section>

    <section class="credits" id="credits">
      <h2 class="fn-title-1 title-credits">Види кредитів для бізнесу</h2>

      <div class="credit-item">
        <div class="preview">
          <img class="logo" src="@/assets/landing-credit-info/credit-one.svg" alt="credit-img">
        </div>

        <div class="content">
          <h3 class="title fn-title-1">Кредит “Зручний”</h3>

          <p class="text m-body-m">
            Кредит без застави на будь-які бізнес-цілі. Надається у вигляді безготівкових коштів відразу всією сумою на
            поточний рахунок з терміном погашення до 36 міс. та переплатою в місяць від 1,65%
          </p>

          <div class="buttons">
<!--            <button class="large-btn main-btn second-color" v-scroll-to="'#credit-form'" v-on:click="defaultCredit = 'CREDIT'">Отримати кредит</button>-->
            <a target="_blank" class="large-btn second-btn second-color" href="https://bankalliance.ua/msb/credit/comfort/?utm_source=site&utm_medium=SiteMsbCredit">Детальніше</a>
          </div>
        </div>
      </div>

      <div class="credit-item">
        <div class="preview">
          <img class="logo" src="@/assets/landing-credit-info/credit-three.svg" alt="credit-img">
        </div>

        <div class="content">
          <h3 class="title fn-title-1">Овердрафт</h3>

          <p class="text m-body-m">
            Кредит без застави на термінові платежі на поповнення обігових коштів при нестачі власних коштів на рахунку.
            Надається у вигляді овердрафту на рахунок від 0% річних з умовою обнулення до 90 днів та з можливістю
            зняття готівкою.
          </p>

          <div class="buttons">
            <button class="large-btn main-btn second-color" v-scroll-to="'#credit-form'" v-on:click="defaultCredit = 'OVER'">Отримати кредит</button>
            <button class="large-btn second-btn second-color" v-on:click="overdraft = true">Детальніше</button>
          </div>
        </div>
      </div>

      <div class="credit-item">
        <div class="preview">
          <img class="logo" src="@/assets/landing-credit-info/credit-two.svg" alt="credit-img">
        </div>

        <div class="content">
          <h3 class="title fn-title-1">Кредитна лінія «Зручна»</h3>

          <p class="text m-body-m">
            На поповнення коштів та планові закупівлі.
            <br>
            Не потребує застави.
            <br>
            Передбачає багаторазове використання в рамках встановленого ліміту.
          </p>

          <div class="buttons">
            <button class="large-btn main-btn second-color" v-scroll-to="'#credit-form'" v-on:click="defaultCredit = 'VKL'">Отримати кредит</button>
            <button class="large-btn second-btn second-color" v-on:click="vkl = true">Детальніше</button>
          </div>
        </div>
      </div>
    </section>

    <section class="credit-form" id="credit-form">
      <h3 class="title fn-title-1">Залиште заявку</h3>
      <CreditForm :type="type" :defaultCredit="defaultCredit"/>
    </section>

    <footer class="footer">
      <p class="copyright">
        <span class="company-name">Alliance Bank.</span>
        Всі права захищені © {{year}}
      </p>
    </footer>

    <PopUp v-if="ComfortableCreditInfo" :width="PopupWidth" :height="PopupHeight" :max-height="PopupMaxHeight" @close='close' :popUpButton="true">
      <ComfortableCreditInfo :type="type" v-on:update:type="type = $event"/>
      <button slot="button"
              class="main-btn second-color large-btn-100 popup-btn"
              v-scroll-to="'#credit-form'"
              v-on:click="defaultCredit = 'CREDIT'"
      >Отримати кредит</button>
    </PopUp>

    <PopUp v-if="overdraft" :width="PopupWidth" :height="PopupHeight" :max-height="PopupMaxHeight" @close='close' :popUpButton="true">
      <Overdraft :type="type" v-on:update:type="type = $event"/>
      <button slot="button"
              class="main-btn second-color large-btn-100 popup-btn"
              v-scroll-to="'#credit-form'"
              v-on:click="defaultCredit = 'OVER'"
      >Отримати кредит</button>
    </PopUp>

    <PopUp v-if="vkl" :width="PopupWidth" :height="PopupHeight" :max-height="PopupMaxHeight" @close='close' :popUpButton="true">
      <VKL :type="type" v-on:update:type="type = $event"/>
      <button slot="button"
              class="main-btn second-color large-btn-100 popup-btn"
              v-scroll-to="'#credit-form'"
              v-on:click="defaultCredit = 'VKL'"
      >Отримати кредит</button>
    </PopUp>
  </div>
</template>

<script>
import CreditForm from '@/components/credit-form/CreditFormNew.vue'
import PopUp from '@/components/Ui-new/PopUp.vue'
import ComfortableCreditInfo from '@/components/landing-credit-info/ComfortableCreditInfo.vue'
import Overdraft from '@/components/landing-credit-info/Overdraft.vue'
import VKL from '@/components/landing-credit-info/VKL.vue'

export default {
  components: {
    CreditForm,
    PopUp,
    ComfortableCreditInfo,
    Overdraft,
    VKL
  },
  data () {
    return {
      year: (new Date()).getFullYear(),
      type: 'flp',
      defaultCredit: 'CREDIT',
      ComfortableCreditInfo: false,
      overdraft: false,
      vkl: false,
      PopupHeight: 'auto',
      PopupWidth: '600px',
      PopupMaxHeight: '600px'
    }
  },
  methods: {
    close (data) {
      this.ComfortableCreditInfo = data.close
      this.overdraft = data.close
      this.vkl = data.close
    },
    onResize () {
      this.PopupHeight = document.documentElement.clientWidth < 900 ? '100vh' : 'auto'
      this.PopupWidth = document.documentElement.clientWidth < 900 ? '100%' : '600px'
      this.PopupMaxHeight = document.documentElement.clientWidth < 900 ? '100%' : '80vh'
    }
  },
  mounted () {
    if (this.$route.path === '/overdraft') {
      this.overdraft = true
    } else if (this.$route.path === '/comfortable-credit') {
      this.ComfortableCreditInfo = true
    }
  },
  created () {
    window.addEventListener('resize', this.onResize)
    this.onResize()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  }
}
</script>

<style scoped lang="less">
.credit-info {
  padding: 0 160px;

  @media (max-width: 1280px) {
    padding: 0 80px;
  }

  .popup-btn {
    //margin: 40px;
  }

  .main-section {
    display: flex;
    height: 100vh;
    position: relative;

    .column {
      width: 50%;
    }

    .logo {
      margin: 20vh 0 0 0;
      width: 206px;
    }

    .title-wrapper {
      position: absolute;
      top: calc(50vh - 108px);

      @media (max-width: 1440px) {
        top: calc(50vh - 84px);
      }

      .main-title {
        margin: 0 0 40px 0;
        font-size: 40px;
        line-height: 60px;
        color: var(--main-base);

        @media (max-width: 1440px) {
          font-size: 28px;
          line-height: 36px;
        }

        .subtitle {
          display: block;
          font-weight: 400;
        }
      }
    }

    .main-banner {
      background: url(~@/assets/landing-credit-info/main-banner.svg) no-repeat 50% 50%;
      background-size: contain;
    }
  }
  @media (max-width: 1200px) {
    padding: 0 8px;

    .main-section {
      flex-direction: column;
      height: auto;

      .column {
        width: 100%;
      }

      .logo {
        width: 120px;
        margin: 60px 0 77px 0;
      }

      .title-wrapper {
        position: initial;

        .main-title {
          .subtitle {
            display: inline;
          }
        }
      }
    }

    .main-banner {
      height: 550px;
    }
  }

  .credits {
    .title-credits {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 80px 0;
      color: var(--black);
      font-weight: 600;
      font-size: 28px;
      line-height: 42px;

      @media (max-width: 1440px) {
        margin: 60px 0;
      }
    }

    .credit-item {
      display: flex;
      align-items: center;
      height: 424px;
      background: var(--grey-250);
      border: 1px solid var(--grey-230);
      border-radius: var(--default-br);

      .preview {
        width: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .content {
        width: 50%;
        max-width: 440px;

        .title {
          margin: 0 0 16px 0;
        }

        .text {
          font-size: 14px;
          line-height: 20px;
          margin: 0 0 40px 0;
          letter-spacing: -0.02em;
        }
      }

      .buttons {
        display: flex;

        button + button {
          margin: 0 0 0 8px;
        }
      }
    }

    .credit-item + .credit-item {
      margin: 40px 0 0 0;
    }

    @media (max-width: 1200px) {
      .title-credits {
        padding: 0;
        margin: 0 0 58px 0;
        align-items: center;
      }

      .credit-item {
        flex-direction: column;
        padding: 16px;
        height: auto;

        .preview {
          margin: 0 0 45px 0;
          width: 100%;

          img {
            max-width: 100%;
          }
        }

        .content {
          width: 100%;
          max-width: 100%;

          .title {
            text-align: center;
            margin: 0 0 21px 0;
          }

          .text {
            margin: 0 0 40px 0;
            text-align: center;
          }
        }

        .buttons {
          flex-direction: column;
          width: 100%;

          button {
            width: 100%;
          }

          button + button {
            margin: 8px 0 0 0;
          }
        }
      }
    }
  }

  .credit-form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .title {
      margin: 80px 0 41px 0;
      font-size: 28px;
      line-height: 42px;
    }

    @media (max-width: 1200px) {
      width: 100%;
    }
  }

  .footer {
    margin: 160px 0 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 119px;

    .copyright {
      margin: 0;
      color: var(--grey-140);
      font-family: Montserrat;
      font-size: 16px;
      line-height: 30px;
    }

    @media (max-width: 1200px) {
      margin: 84px 0 0 0;

      .copyright {
        .company-name {
          display: block;
        }
      }
    }
  }
}
</style>
